var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQcTray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 2.08337H7.54687C6.33958 2.08337 5.73646 2.08337 5.24896 2.25317C4.78951 2.41642 4.3738 2.68323 4.03403 3.03294C3.69426 3.38265 3.43953 3.80587 3.28958 4.26983C3.125 4.77192 3.125 5.39275 3.125 6.63546V21.223C3.125 22.1167 4.15104 22.5917 4.8 21.998C4.98207 21.8297 5.22086 21.7363 5.46875 21.7363C5.71664 21.7363 5.95543 21.8297 6.1375 21.998L6.64062 22.4584C6.95959 22.7533 7.37806 22.9172 7.8125 22.9172C8.24694 22.9172 8.66541 22.7533 8.98437 22.4584C9.30334 22.1634 9.72181 21.9996 10.1562 21.9996C10.5907 21.9996 11.0092 22.1634 11.3281 22.4584C11.6471 22.7533 12.0656 22.9172 12.5 22.9172C12.9344 22.9172 13.3529 22.7533 13.6719 22.4584C13.9908 22.1634 14.4093 21.9996 14.8437 21.9996C15.2782 21.9996 15.6967 22.1634 16.0156 22.4584C16.3346 22.7533 16.7531 22.9172 17.1875 22.9172C17.6219 22.9172 18.0404 22.7533 18.3594 22.4584L18.8625 21.998C19.0446 21.8297 19.2834 21.7363 19.5312 21.7363C19.7791 21.7363 20.0179 21.8297 20.2 21.998C20.849 22.5917 21.875 22.1167 21.875 21.223V6.63546C21.875 5.39275 21.875 4.77087 21.7104 4.27087C21.5606 3.80672 21.3059 3.38329 20.9662 3.03339C20.6264 2.6835 20.2106 2.41652 19.751 2.25317C19.2635 2.08337 18.6604 2.08337 17.4531 2.08337Z",
    stroke: "#1B385F",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89584 10.8334L11.3844 12.5L15.1042 8.33337",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 16.1459H17.1875",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQcTray);
export default __webpack_public_path__ + "static/media/QC Tray.3fc7003e19109df600b0108e47f15061.svg";
export { ForwardRef as ReactComponent };